import { render, staticRenderFns } from "./StudentListF.vue?vue&type=template&id=82cd07dc&"
import script from "./StudentListF.vue?vue&type=script&lang=js&"
export * from "./StudentListF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports